export default "__VITE_ASSET__064eef82__"